// ============================================================
// The nine characteristics, by id and name: a leaf, so the effect readers
// (`effectItems`) and the sheet's edits (`sheetPatches`) can both name them
// without importing each other's resolver.
// ============================================================
import type { CharacteristicId } from './types';

/** The nine characteristics in sheet order, short and long names. */
export const CHARACTERISTICS: { id: CharacteristicId; short: string; name: string }[] = [
  { id: 'ws', short: 'WS', name: 'Weapon Skill' },
  { id: 'bs', short: 'BS', name: 'Ballistic Skill' },
  { id: 'str', short: 'S', name: 'Strength' },
  { id: 'tgh', short: 'T', name: 'Toughness' },
  { id: 'agi', short: 'Ag', name: 'Agility' },
  { id: 'int', short: 'Int', name: 'Intelligence' },
  { id: 'per', short: 'Per', name: 'Perception' },
  { id: 'wp', short: 'WP', name: 'Willpower' },
  { id: 'fel', short: 'Fel', name: 'Fellowship' },
];
